export default __webpack_public_path__ + "static/media/immutable.cba0c608.svg";